<script>
import classModifierMixin from './mixins/class-modifier-mixin'
export default {
	name: 'BaseHeadingTable',
	mixins: [classModifierMixin],
	props: {
		tableStructure: {
			type: Array
		}
	}
}
</script>
<template>
	<div class="base-heading-table">
		<div class="base-heading-table__section" v-for="section in tableStructure" :key="section.id">
			<div v-if="section.heading" class="base-heading-table__heading">{{ section.heading }}</div>
			<div v-else class="base-heading-table__separator"></div>
			<div v-for="field in section.fields" class="base-heading-table__field" :key="field.id">
				<div class="base-heading-table__row  base-heading-table__label" >{{ field.label }}</div>
				<div class="base-heading-table__row  base-heading-table__value" >{{ field.value }}</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss">
	.base-heading-table {
		border: 1px solid var(--border-variant-dark);
		border-spacing: 0;
		color: var(--on-surface);
		@media (max-width: 350px) {
			font-size: 0.9rem;
		}
		&__section:first-child &__heading {
			border-top: none;
		}
		&__heading {
			display: flex;
			align-items: center;
			padding: 0.3rem 0.5rem;
			font-size: var(--font-size-body-2);
			font-weight: var(--font-weight-body-2);
			background-color: #f9f9f9;
			border-bottom: 1px solid var(--border-variant-light);
			border-top: 1px solid var(--border-variant-light);
			height: fit-content;
			@media (max-width: 500px) {
				padding: 0.5rem 0.5rem;
			}
		}
		&__separator {
			width: 100%;
			height: 1px;
			border-bottom: 1px solid var(--border-variant-light);
		}
		&__row {
			display: flex;
			align-items: center;
			height: fit-content;
			background-color: var(--colour-light);
		}
		&__field {
			padding: 0.3rem 1rem;
			border-bottom: 1px solid var(--border-variant-light);
			&:last-child {
				border-bottom: none;
			}
		}
		&__label {
			font-weight: var(--font-weight-body-2);
			margin-bottom: 0.2rem;
			height: fit-content;
		}
		&__value {
			word-break: break-word;
			margin-top: 0.2rem;
			min-height: 1rem;
			height: fit-content;
            font-size: var(--font-size-caption);
            font-weight: var(--font-weight-caption);
			@media (max-width: 500px) {
				margin-bottom: 0.3rem;
				font-size: 0.9rem;
			}
		}
	}
</style>
